import { css } from 'styled-components';

/**
 * Shared input wrapper/container styles used across LytTextField,
 * MapEntitySearchInput, and any other input components that should
 * have a consistent look and feel.
 *
 * Expects transient props: $hasError (optional, default false)
 */
export const inputWrapperStyles = css`
    height: ${({ $isCompact }) => $isCompact ? '32px' : '40px'};
    border-radius: 4px;
    border: 2px solid ${({ theme, $hasError }) => $hasError
        ? theme.components.lyt_input.border.error
        : theme.components.lyt_input.border.default};
    background: ${({ theme, $hasError }) => $hasError
        ? theme.components.lyt_input.background.error
        : theme.components.lyt_input.background.default};

    &:hover {
        background: ${({ theme, $hasError }) => $hasError
            ? theme.components.lyt_input.background.error
            : theme.components.lyt_input.background.hover};
    }

    &:focus-within {
        background: ${({ theme, $hasError }) => $hasError
            ? theme.components.lyt_input.background.error
            : theme.components.lyt_input.background.focus};
        border-color: ${({ theme, $hasError }) => $hasError
            ? theme.components.lyt_input.border.error
            : theme.components.lyt_input.border.focus};
    }
`;

/**
 * Shared base input element styles for the actual <input> element.
 * Ensures consistent typography, color, and placeholder styling.
 */
export const inputBaseStyles = css`
    border: none;
    background: transparent;
    font-family: "IBM Plex Sans";
    font-size: 16px;
    line-height: 1.5;
    color: ${({ theme }) => theme?.text?.default};

    &::placeholder {
        color: #7f8084;
    }

    &:focus {
        outline: none;
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }
`;
